import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
import SwitchToggle from "../../components/layout/SwitchToggle";
const ConsejeriaForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>

      <Card padding>

        {value && Object.keys(value).length !== 0 &&<FormGroup>
          <label>Activo</label>
          <SwitchToggle
            size={24}
            label={""}
            {...register("activo")}
          />
          {errors.activo && <p style={{color: 'red'}}>{errors.activo?.message}</p>}
        </FormGroup>}

        <FormGroup>
          <label>Codigo</label>
          <Input type='text' {...register("codigo", {required: "Campo obligatorio"})}/>
          {errors.codigo && <p style={{color: 'red'}}>{errors.codigo?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Nombre</label>
          <Input type='text' {...register("nombre", {required: "Campo obligatorio"})}/>
          {errors.nombre && <p style={{color: 'red'}}>{errors.nombre?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Presentacion</label>
          <Input type='text' {...register("presentacion", {required: "Campo obligatorio"})}/>
          {errors.presentacion && <p style={{color: 'red'}}>{errors.presentacion?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Descripción</label>
          <Input type='text' {...register("descripcion", {required: "Campo obligatorio"})}/>
          {errors.descripcion && <p style={{color: 'red'}}>{errors.descripcion?.message}</p>}
        </FormGroup>

        <Row>
          <Col>
            <FormGroup>
              <label>Precio</label>
              <Input type='number' {...register("precio",
                {
                  required: "Campo obligatorio",
                })}/>
              {errors.precio && <p style={{color: 'red'}}>{errors.precio?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Porcentaje de descuento</label>
              <Input type='number' {...register("porcDesc", {
                required: "Campo obligatorio",
                validate: value => (parseFloat(value)<= 1 && parseFloat(value) > 0) || "El valor debe ser entre 0 y 1"
              })}/>
              {errors.porcDesc && <p style={{color: 'red'}}>{errors.porcDesc?.message}</p>}
            </FormGroup>
          </Col>
        </Row>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default ConsejeriaForm;
